import Footer from "../../components/common/layout/Footer";
import { Breadcrumbs, JobPosting, OtherServices, IntroSection, OtherValues } from "@/components/features/careers";
import SEO from "@/components/common/seo/seo";

export default function Careers() {
    return(
        <div>
            <SEO
                title="Careers - SAN micron"
                description="Join us at SAN micron as we work together to explore new possibilities. We look forward to helping your business grow, innovate, and succeed in an ever-evolving digital landscape."
            />
            <Breadcrumbs />
            <IntroSection />
            <JobPosting />
            <OtherServices />
            {/* <CallToAction /> */}
            <OtherValues />
            <Footer />
        </div>
    );
}